import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';

import styles from './GodsAndKings.module.css';

const GodsAndKingsJackpot: FC<StandardJackpotProps> = (props) => {
  const godsAndKingsIcons = {
    panel: '/group_gods_and_kings/panel',
    grand: '/group_gods_and_kings/grand',
    major: '/group_gods_and_kings/major',
    minor: '/group_gods_and_kings/minor',
    mini: '/group_gods_and_kings/mini',
  };

  return (
    <StandardJackpot
      {...props}
      icons={godsAndKingsIcons}
      className={styles.godsAndKingsTheme}
    />
  );
};

export default memo(GodsAndKingsJackpot);
